import { Col, Row } from "reactstrap";
import React from "react";
import { FooterWrapper } from "../_UI/StyledComponents";
import { numberToGermanLocaleWithThousandSeperator, toGermanDateString } from "../helper/formatting-helper";
import { DocumentLineItem } from "../_components/DocumentLineItem";
import { determineAdditionalInformationLinesForLineItem } from "../_helpers/AdditionalInformationHelper";
import styled from "styled-components";
import stringUtils from "../_helpers/string-utils";

export const GiftCardLines = ({ giftCardLines, locale, currencyCode }) => {
    return (<Row>
        <Col className="col-12">
            <br />
            <hr />
            {giftCardLines.map((line, index) => {
                return (<div
                    key={index}
                    dangerouslySetInnerHTML={{
                        __html: locale.GIFT_CARD_LINE.replaceAll("${GIFT_CARD_CODE}", line.giftCardCode ? " (****" + line.giftCardCode + ")" : "").replaceAll("${GIFT_CARD_AMOUNT}", line.usedAmount + "" + currencyCode),
                    }}
                />);
            })}
        </Col>
    </Row>);
};

export const DiscountCodes = ({ discountLines, locale }) => {
    return (
        <Row>
            <Col className="col-12">
                <br />
                <hr />
                <b>{locale.USED_DISCOUNTS}: </b> {discountLines.map((line) => line.code).join(", ")}
            </Col>
        </Row>
    );
};

export const OpenFiskalLogo = ({ shopId, orderId, ofiKey }) => {
    const params = new URLSearchParams({
        ofiKey: ofiKey,
        shopifyOrderId: orderId,
        shopifyShopDomain: shopId,
        embeddingTarget: "pathway-order-printer",
        variant: "normal",
        fileFormat: "png",
        version: 2,
    });
    const src = `https://app.openfiskal.com/api/integrations/rechnungsprinter-pro/signature-image-for-shopify-order?${params.toString()}`;

    return <img
        src={src}
        width="20%"
        alt="" />;
};

export const AdditionalInformationLines = ({ additionalInformationLines }) => {
    if (!additionalInformationLines || additionalInformationLines.length === 0) {
        return <></>;
    }

    return (
        <Row>
            <Col className="col-12">
                <br />
                <hr />
                {additionalInformationLines
                    .filter((line) => {
                        return !line.linkedLineItemId;
                    })
                    .sort((a, b) =>
                        a.sequenceNumber > b.sequenceNumber
                            ? 1
                            : a.sequenceNumber < b.sequenceNumber
                                ? -1
                                : 0,
                    )
                    .map((line, index) => {
                        return <div key={index} dangerouslySetInnerHTML={{ __html: line.text }} />;
                    })}
            </Col>
        </Row>
    );
};

export const Footer = ({ text }) => {
    return (
        <Row id="footer">
            <Col className="col-12" style={{ marginBottom: ".8em" }}>
                <br />
                <hr />
                <FooterWrapper
                    dangerouslySetInnerHTML={{ __html: text }} />
            </Col>
        </Row>
    );
};

export const InvoiceTotalBox = ({ invoice, isReversalDocument, hasDiscount, color, locale, isMomoxCustomer }) => {
    if (!invoice) {
        return <></>;
    }

    return (
        <Row id="total-box">
            <Col className="col-6"></Col>
            <Col className="col-6">
                <table className="table">
                    <tbody>
                    {hasDiscount && (
                        <>
                            <tr
                                style={{
                                    fontWeight: "bold",
                                }}
                            >
                                <td style={{ color: color }}>{locale.TOTAL_BEFORE_DISCOUNTS}</td>
                                <td></td>
                                <td style={{ textAlign: "right", color: color }}>
                                    {numberToGermanLocaleWithThousandSeperator(
                                        invoice.totalAmountBeforeDiscounts,
                                    )}
                                    {invoice.currencyCode}
                                </td>
                            </tr>
                            <tr>
                                <td>{locale.TOTAL_DISCOUNTS}</td>
                                <td></td>
                                <td style={{ textAlign: "right" }}>
                                    {numberToGermanLocaleWithThousandSeperator(invoice.totalDiscounts)}
                                    {invoice.currencyCode}
                                </td>
                            </tr>
                        </>
                    )}

                    {invoice.totalAmount !== invoice.totalAmountWithoutTax &&
                        <tr
                            style={{
                                fontWeight: "bold",
                            }}
                        >
                            <td style={{ color: color }}>{locale.TOTAL_INCLUDING_VAT}</td>
                            <td></td>
                            <td style={{ textAlign: "right", color: color }}>
                                {numberToGermanLocaleWithThousandSeperator(invoice.totalAmount)}
                                {invoice.currencyCode}
                            </td>
                        </tr>
                    }

                    {(!invoice.taxLines || invoice.taxLines.length <= 1) &&
                        <tr>
                            <td>{locale.TOTAL_EXCLUDING_VAT}</td>
                            <td></td>
                            <td style={{ textAlign: "right" }}>
                                {invoice.totalAmountWithoutTax
                                    ? numberToGermanLocaleWithThousandSeperator(invoice.totalAmountWithoutTax)
                                    : "0,00"}
                                {invoice.currencyCode}
                            </td>
                        </tr>
                    }

                    {invoice.taxLines && invoice.taxLines.length > 1 &&
                        invoice.taxLines.map((taxLine, index) => {
                            let vatDescription = taxLine.vatDescription
                                ? "(" + taxLine.vatDescription + ") "
                                : "";
                            return (
                                <tr key={index}>
                                    <td>
                                        {locale.TOTAL_EXCLUDING_VAT +
                                            "(" +
                                            vatDescription +
                                            taxLine.taxRatePercentageString +
                                            ")"}
                                    </td>
                                    <td></td>
                                    <td style={{ textAlign: "right" }}>
                                        {taxLine.amount
                                            ? numberToGermanLocaleWithThousandSeperator(taxLine.includesTaxes ? Number(taxLine.amount) - Number(taxLine.taxAmount) : Number(taxLine.amount))
                                            : "0,00"}
                                        {invoice.currencyCode}
                                    </td>
                                </tr>
                            );
                        })}

                    {invoice.taxLines &&
                        invoice.taxLines.map((taxLine, index) => {
                            let vatDescription = taxLine.vatDescription
                                ? "(" + taxLine.vatDescription + ") "
                                : "";
                            return (
                                <tr key={index}>
                                    <td>
                                        {locale.TAX_ABBREVIATED +
                                            " " +
                                            vatDescription +
                                            taxLine.taxRatePercentageString
                                        }
                                    </td>
                                    <td></td>
                                    <td style={{ textAlign: "right" }}>
                                        {taxLine.taxAmount
                                            ? numberToGermanLocaleWithThousandSeperator(taxLine.taxAmount)
                                            : "0,00"}
                                        {invoice.currencyCode}
                                    </td>
                                </tr>
                            );
                        })}

                    {!isReversalDocument &&
                        <>
                            {(invoice.paidLines && invoice.paidLines.length > 0) && (
                                <tr>
                                    <td>{locale.PAID}</td>
                                    <>
                                        <td style={{ textAlign: "right" }}>
                                            {invoice.paidLines.map((line, index) => {
                                                return (
                                                    <div key={"method-" + index}>
                                                        {line.method
                                                            ? line.method.replaceAll(
                                                                "${GIFT_CARD}",
                                                                locale.GIFT_CARD,
                                                            )
                                                            : ""}
                                                    </div>
                                                );
                                            })}
                                        </td>

                                        <td style={{ textAlign: "right" }}>
                                            {
                                                invoice.paidLines.map((line, index) => {
                                                    return (
                                                        <div key={"amount-" + index}>
                                                            {numberToGermanLocaleWithThousandSeperator(
                                                                line.amount,
                                                            ) + invoice.currencyCode}
                                                        </div>
                                                    );
                                                })}
                                        </td>
                                    </>
                                </tr>
                            )}

                            {(invoice.pendingAmount !== undefined && invoice.pendingAmount !== null) &&
                                <tr
                                    style={{
                                        fontWeight: "bold",
                                    }}
                                >
                                    <td style={{ color: color }}>{locale.UNPAID_AMOUNT}</td>
                                    <td></td>
                                    <td style={{ textAlign: "right", color: color }}>
                                        {invoice.pendingAmount ?
                                            numberToGermanLocaleWithThousandSeperator(invoice.pendingAmount)
                                            : "0,00"}
                                        {invoice.currencyCode}
                                    </td>
                                </tr>
                            }
                        </>
                    }
                    </tbody>
                </table>
            </Col>
        </Row>
    );
};

export const InvoiceLineItems = ({ invoice, additionalInformationLines, hasDiscount, color, locale }) => {
    if (!invoice) {
        return <></>;
    }

    return (
        <Row id="invoice-line-items">
            <Col className="col-12">
                <h5 style={{
                    marginBottom: "5px",
                    fontSize: "0.9rem",
                }}>{locale.INVOICE_LINE_ITEMS_TITLE}</h5>
                <table className="table table-borderless"
                       style={{ marginBottom: "0px", padding: ".1rem .1rem" }}>
                    <thead>
                    <tr>
                        <th style={{
                            color: color,
                        }}>{locale.PRODUCT}</th>
                        <th style={{
                            color: color,
                        }}>{locale.PRODUCT_DESCRIPTION}</th>
                        <th style={{
                            color: color,
                        }}>{locale.PRODUCT_AMOUNT}</th>
                        <th style={{ color: color, textAlign: "right" }}>{locale.PRODUCT_SINGLE_PRICE}</th>
                        {hasDiscount && <th style={{ color: color, textAlign: "right" }}>{locale.DISCOUNT}</th>}
                        <th style={{ color: color, textAlign: "right" }}>{locale.TAX_ABBREVIATED}</th>
                        <th style={{ color: color, textAlign: "right" }}>{locale.TAX_AMOUNT}</th>
                        <th style={{ color: color, textAlign: "right" }}>{locale.BRUTTO}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {invoice.lineItems &&
                        invoice.lineItems.map((lineItem, index) => {
                            return (
                                <DocumentLineItem
                                    key={index}
                                    lineItem={lineItem}
                                    currencyCode={invoice.currencyCode}
                                    showDiscount={hasDiscount}
                                    additionalInformationLineItems={determineAdditionalInformationLinesForLineItem(
                                        lineItem,
                                        additionalInformationLines,
                                    )}
                                    color={index % 2 === 0 ? "#F2F2F2" : "white"}
                                    locale={locale}
                                />
                            );
                        })}

                    {invoice.shipping && (
                        <tr style={{ borderTop: "2px solid lightgrey" }}>
                            <td>{locale.DELIVERY_COST}</td>
                            <td />
                            <td />
                            <td style={{ textAlign: "right" }}>
                                {numberToGermanLocaleWithThousandSeperator(
                                    invoice.shipping.netAmount,
                                )}
                                {invoice.currencyCode}</td>
                            {hasDiscount && <td />}
                            <td style={{ textAlign: "right" }}>
                                {invoice.shipping.taxLines &&
                                    invoice.shipping.taxLines
                                        .filter(taxLine => !taxLine.mockItem)
                                        .map((taxLine, index) => {
                                            return (
                                                <div key={index}>
                                                    {taxLine.taxRatePercentageString}
                                                    <br />
                                                </div>
                                            );
                                        })}
                            </td>
                            <td style={{ textAlign: "right" }}>
                                {invoice.shipping.taxLines &&
                                    invoice.shipping.taxLines
                                        .filter(taxLine => !taxLine.mockItem)
                                        .map((taxLine, index) => {
                                            return (
                                                <div key={index}>
                                                    {numberToGermanLocaleWithThousandSeperator(taxLine.taxAmount)}
                                                    {invoice.currencyCode}
                                                    <br />
                                                </div>
                                            );
                                        })}
                            </td>
                            <td style={{ textAlign: "right" }}>
                                {invoice.shipping.discount && (!invoice.shipping.taxLines || invoice.shipping.taxLines.every(taxLine => !taxLine.mockItem)) ? (
                                    <VerticalCell>
                                        <div>
                                            <s>
                                                {numberToGermanLocaleWithThousandSeperator(
                                                    invoice.shipping.totalAmount,
                                                )}
                                                {invoice.currencyCode}
                                            </s>
                                        </div>
                                        <div>
                                            {numberToGermanLocaleWithThousandSeperator(
                                                invoice.shipping.totalAmount - invoice.shipping.discount,
                                            )}
                                            {invoice.currencyCode}
                                        </div>
                                    </VerticalCell>
                                ) : (
                                    <p>
                                        {numberToGermanLocaleWithThousandSeperator(
                                            invoice.shipping.totalAmount,
                                        )}
                                        {invoice.currencyCode}
                                    </p>
                                )}
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </Col>
        </Row>
    );
};

export const BasicInvoiceInformationBox = ({ invoice, showDeliveryDate, invoiceDate, locale }) => {
    return (
        <Row id="payment">
            <Col className="col-6">
                <Row>
                    <Col className="col-6">
                        <b>{locale.ORDER_NUMBER}:</b>
                    </Col>
                    <Col className="col-6">{invoice.orderName}</Col>
                </Row>
                {!stringUtils.isBlank(invoice.paymentMethod) &&
                    <Row>
                        <Col className="col-6">
                            <b>{locale.PAYMENT_METHOD}:</b>
                        </Col>
                        <Col className="col-6">
                            {invoice.paymentMethod
                                ? invoice.paymentMethod.replaceAll("${GIFT_CARD}", locale.GIFT_CARD)
                                : ""}
                        </Col>
                    </Row>
                }
            </Col>

            <Col className="col-6">
                <Row>
                    <Col className="col-6">
                        <b>{locale.CREATION_DATE}:</b>
                    </Col>
                    <Col className="col-6">{invoiceDate}</Col>
                </Row>
                {showDeliveryDate && (
                    <Row>
                        <Col className="col-6">
                            <b>{locale.DELIVERY_DATE}:</b>
                        </Col>
                        <Col className="col-6">
                            <b>
                                {invoice.deliveryDate ? toGermanDateString(new Date(invoice.deliveryDate)) : ""}
                            </b>
                        </Col>
                    </Row>
                )}
            </Col>
        </Row>
    );
};

export const AddressBox = ({ document, leftAlignedAddress, displayEmailAddresses, color, locale }) => {
    if (leftAlignedAddress) {
        return (
            <Row id="delivery">
                <Col
                    className={document.deliveryAddress ? "col-3" : "col-6"}
                    style={{ display: "inline", lineHeight: "15px" }}
                >
                    {document.customer && (
                        <>
                            <h5
                                style={{
                                    marginBottom: "0.75rem",
                                    fontSize: "1rem",
                                    color: color,
                                }}
                            >
                                {locale.CUSTOMER}
                            </h5>
                            {document.customer.companyName &&
                                <p className="pSubHeader">{document.customer.companyName}</p>
                            }
                            {document.customer.personName &&
                                <p className="pSubHeader">{document.customer.personName}</p>
                            }

                            {displayEmailAddresses && (
                                <p className="invoice">{document.customer.email}</p>
                            )}

                            {document.customer.line2 && document.customer.line2.length < 6 ? (
                                <p className="invoice">
                                    {document.customer.line1} {document.customer.line2}
                                </p>
                            ) : (
                                <>
                                    <p className="invoice">{document.customer.line1}</p>
                                    <p className="invoice">{document.customer.line2}</p>
                                </>
                            )}

                            <p className="invoice">
                                {document.customer.zip} {document.customer.city}
                            </p>
                            <p className="invoice">{document.customer.countryName}</p>
                            {document.customer.vatId && (
                                <p className="invoice">
                                    {locale.VAT_ID}: {document.customer.vatId}
                                </p>
                            )}
                        </>
                    )}
                </Col>

                {document.deliveryAddress && <Col className={"col-3"}>&nbsp;</Col>}

                {document.deliveryAddress && (
                    <Col className="col-3" style={{ display: "inline", lineHeight: "15px" }}>
                        <>
                            <h5
                                style={{
                                    marginBottom: "0.75rem",
                                    fontSize: "1rem",
                                    color: color,
                                }}
                            >
                                {locale.DELIVERY_ADDRESS}
                            </h5>
                            {document.deliveryAddress.companyName &&
                                <p className="pSubHeader">{document.deliveryAddress.companyName}</p>
                            }
                            {document.deliveryAddress.personName &&
                                <p className="pSubHeader">{document.deliveryAddress.personName}</p>
                            }

                            {document.deliveryAddress.line2 && document.deliveryAddress.line2.length < 6 ? (
                                <p className="invoice">
                                    {document.deliveryAddress.line1} {document.deliveryAddress.line2}
                                </p>
                            ) : (
                                <>
                                    <p className="invoice">{document.deliveryAddress.line1}</p>
                                    <p className="invoice">{document.deliveryAddress.line2}</p>
                                </>
                            )}

                            <p className="invoice">
                                {document.deliveryAddress.zip} {document.deliveryAddress.city}
                            </p>
                            <p className="invoice">{document.deliveryAddress.countryName}</p>
                            {document.deliveryAddress.vatId && (
                                <p>
                                    {locale.VAT_ID}: {document.deliveryAddress.vatId}
                                </p>
                            )}
                        </>
                    </Col>
                )}

                <Col
                    className={document.deliveryAddress ? "col-3" : "col-6"}
                    style={{ display: "inline", lineHeight: "15px" }}
                >
                    {document.seller && (
                        <>
                            <h5
                                style={{
                                    marginBottom: "0.75rem",
                                    fontSize: "1rem",
                                    color: color,
                                }}
                            >
                                {locale.VENDOR}
                            </h5>
                            {document.seller.companyName &&
                                <p className="pSubHeader">{document.seller.companyName}</p>
                            }
                            {document.seller.personName &&
                                <p className="pSubHeader">{document.seller.personName}</p>
                            }

                            {displayEmailAddresses && (
                                <p className="invoice">{document.seller.email}</p>
                            )}

                            <p className="invoice">{document.seller.line1}</p>
                            {document.seller.line2 &&
                                <p className="invoice">{document.seller.line2}</p>}
                            <p className="invoice">
                                {document.seller.zip} {document.seller.city}
                            </p>
                            <p className="invoice">{document.seller.countryName}</p>
                            {document.seller.vatId && (
                                <p className="invoice">
                                    {locale.VAT_ID}: {document.seller.vatId}
                                </p>
                            )}
                            {document.seller.taxId && (
                                <p className="invoice">
                                    {locale.TAX_ID}: {document.seller.taxId}
                                </p>
                            )}
                        </>
                    )}
                </Col>
            </Row>
        );
    } else {
        return (
            <Row id="delivery">
                <Col
                    className={document.deliveryAddress ? "col-3" : "col-6"}
                    style={{ display: "inline", lineHeight: "15px" }}
                >
                    {document.seller && (
                        <>
                            <h5
                                style={{
                                    marginBottom: "0.75rem",
                                    fontSize: "1rem",
                                    color: color,
                                }}
                            >
                                {locale.VENDOR}
                            </h5>
                            {document.seller.companyName &&
                                <p className="pSubHeader">{document.seller.companyName}</p>
                            }
                            {document.seller.personName &&
                                <p className="pSubHeader">{document.seller.personName}</p>
                            }

                            {displayEmailAddresses && (
                                <p className="invoice">{document.seller.email}</p>
                            )}
                            <p className="invoice">{document.seller.line1}</p>
                            {document.seller.line2 &&
                                <p className="invoice">{document.seller.line2}</p>}
                            <p className="invoice">
                                {document.seller.zip} {document.seller.city}
                            </p>
                            <p className="invoice">{document.seller.countryName}</p>
                            {document.seller.vatId && (
                                <p className="invoice">
                                    {locale.VAT_ID}: {document.seller.vatId}
                                </p>
                            )}
                            {document.seller.taxId && (
                                <p className="invoice">
                                    {locale.TAX_ID}: {document.seller.taxId}
                                </p>
                            )}
                        </>
                    )}
                </Col>

                {document.deliveryAddress && <Col className={"col-3"}>&nbsp;</Col>}

                <Col
                    className={document.deliveryAddress ? "col-3" : "col-6"}
                    style={{ display: "inline", lineHeight: "15px" }}
                >
                    {document.customer && (
                        <>
                            <h5
                                style={{
                                    marginBottom: "0.75rem",
                                    fontSize: "1rem",
                                    color: color,
                                }}
                            >
                                {locale.CUSTOMER}
                            </h5>
                            {document.customer.companyName &&
                                <p className="pSubHeader">{document.customer.companyName}</p>
                            }
                            {document.customer.personName &&
                                <p className="pSubHeader">{document.customer.personName}</p>
                            }

                            {displayEmailAddresses && (
                                <p className="invoice">{document.customer.email}</p>
                            )}

                            {document.customer.line2 && document.customer.line2.length < 6 ? (
                                <p className="invoice">
                                    {document.customer.line1} {document.customer.line2}
                                </p>
                            ) : (
                                <>
                                    <p className="invoice">{document.customer.line1}</p>
                                    <p className="invoice">{document.customer.line2}</p>
                                </>
                            )}

                            <p className="invoice">
                                {document.customer.zip} {document.customer.city}
                            </p>
                            <p className="invoice">{document.customer.countryName}</p>
                            {document.customer.vatId && (
                                <p className="invoice">
                                    {locale.VAT_ID}: {document.customer.vatId}
                                </p>
                            )}
                        </>
                    )}
                </Col>

                {document.deliveryAddress && (
                    <Col className="col-3" style={{ display: "inline", lineHeight: "15px" }}>
                        <>
                            <h5
                                style={{
                                    marginBottom: "0.75rem",
                                    fontSize: "1rem",
                                    color: color,
                                }}
                            >
                                {locale.DELIVERY_ADDRESS}
                            </h5>
                            {document.deliveryAddress.companyName &&
                                <p className="pSubHeader">{document.deliveryAddress.companyName}</p>
                            }
                            {document.deliveryAddress.personName &&
                                <p className="pSubHeader">{document.deliveryAddress.personName}</p>
                            }

                            {document.deliveryAddress.line2 && document.deliveryAddress.line2.length < 6 ? (
                                <p className="invoice">
                                    {document.deliveryAddress.line1} {document.deliveryAddress.line2}
                                </p>
                            ) : (
                                <>
                                    <p className="invoice">{document.deliveryAddress.line1}</p>
                                    <p className="invoice">{document.deliveryAddress.line2}</p>
                                </>
                            )}

                            <p className="invoice">
                                {document.deliveryAddress.zip} {document.deliveryAddress.city}
                            </p>
                            <p className="invoice">{document.deliveryAddress.countryName}</p>
                            {document.deliveryAddress.vatId && (
                                <p>
                                    {locale.VAT_ID}: {document.deliveryAddress.vatId}
                                </p>
                            )}
                        </>
                    </Col>
                )}
            </Row>
        );
    }
};

export const Logo = ({ logo, logoAlignment, hidden }) => {
    return (
        <Row id="upperstyle" className="pt-5" style={{ minHeight: "40px" }}>
            <Col className="col-12"
                 style={{ textAlign: logoAlignment }}>
                <img
                    hidden={hidden}
                    style={{ maxHeight: "120px", maxWidth: "240px" }}
                    src={process.env.REACT_APP_S3_BILLING_PUBLIC_URL + "/" + logo}
                    alt="logo"
                />
            </Col>
        </Row>
    );
};

export const InvoiceNumber = ({ invoiceNumber, isReversalDocument, isDummy, testMode, color, locale }) => {
    return (
        <Row className="py-4">
            <Col className="col-6">
                <h4
                    style={{
                        display: "inline",
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                        color: color,
                    }}
                >
                    {isReversalDocument
                        ? locale.REVERSAL_INVOICE + " #" + invoiceNumber + "-Storno"
                        : locale.INVOICE + " " + ((isDummy || testMode)
                        ? "#Muster"
                        : invoiceNumber
                            ? "#" + invoiceNumber
                            : "")}
                </h4>
                <br />
                {isReversalDocument &&
                    <h4 style={{
                        display: "inline",
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                        color: color,
                    }}>
                        {"Zu " + locale.INVOICE + " " + ((isDummy || testMode)
                            ? "#Muster"
                            : invoiceNumber
                                ? "#" + invoiceNumber
                                : "")}
                    </h4>
                }
            </Col>
        </Row>
    );
};

const VerticalCell = styled.div`
    display: grid;
    grid-template-rows: 1fr 1fr;
    row-gap: 0.5rem;
    text-align: right;
`;